/* 4U add-to-cart colour flash.
   When a shopper presses Add to Cart on a product page, the button fills with the
   colour they are adding (Midnight Navy, Ox Blood, ...) for a split second, with a
   quick light sweep across it, then settles back to normal.

   WHERE THE COLOUR COMES FROM, in order:
   1. The real garment: a patch from the middle of that colour's main product photo.
      This keeps the flash true to the fabric with nothing to maintain.
   2. OVERRIDES below: set a hex here to force an exact shade for a colour name.
   3. FALLBACK list below, used only if the photo could not be read.
   4. The colour's swatch image. */
(function(){
  if (window.__fuAtcFlash) return;
  window.__fuAtcFlash = true;

  /* Force an exact shade, e.g. 'arctic grey': '#c3c7cb'. Leave empty to use the photo. */
  var OVERRIDES = {};

  var FALLBACK = {
    'onyx black': '#161616',
    'black': '#161616',
    'black logo': '#161616',
    'midnight navy': '#1c2b47',
    'ox blood': '#5c1a20',
    'glacier': '#e9edf0',
    'white': '#f4f4f2',
    'off-white': '#f1eee7',
    'graphite': '#4c4f54',
    'steel blue': '#4c6b83',
    'arctic grey': '#b9bfc5',
    'stone grey': '#9c9b96',
    'grey logo': '#8b8e93'
  };

  var HOLD = 1000;  /* ms the colour stays on the button before fading back */
  var SAMPLED = {};
  var P = null;
  var last = { x: null, y: null, t: 0 };

  var css = ''
    + '.fu-atc-on{position:relative !important;overflow:hidden !important;}'
    + '.product-form__submit .btn-text{transition:color .25s ease;}'
    + '.fu-atc-on .btn-text{position:relative;z-index:2;}'
    + '.fu-atc-on.fu-atc-tint .btn-text{color:var(--fu-atc-text) !important;}'
    + '.fu-atc-flash{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;border-radius:inherit;pointer-events:none;overflow:hidden;'
    + '-webkit-clip-path:circle(0px at var(--fx) var(--fy));clip-path:circle(0px at var(--fx) var(--fy));'
    + 'animation:fu-atc-in .38s cubic-bezier(.4,0,.2,1) forwards, fu-atc-out .35s ease ' + HOLD + 'ms forwards;}'
    + '.fu-atc-flash::after{content:"";position:absolute;top:0;bottom:0;left:-60%;width:45%;'
    + 'background:linear-gradient(105deg,rgba(255,255,255,0) 0%,rgba(255,255,255,.3) 50%,rgba(255,255,255,0) 100%);'
    + 'transform:skewX(-15deg);animation:fu-atc-shine .7s ease .12s forwards;}'
    + '@keyframes fu-atc-in{to{-webkit-clip-path:circle(160% at var(--fx) var(--fy));clip-path:circle(160% at var(--fx) var(--fy));}}'
    + '@keyframes fu-atc-out{to{opacity:0;}}'
    + '@keyframes fu-atc-shine{to{left:130%;}}'
    + '@media (prefers-reduced-motion:reduce){.fu-atc-flash{-webkit-clip-path:none;clip-path:none;animation:fu-atc-out .35s ease ' + HOLD + 'ms forwards;}.fu-atc-flash::after{display:none;}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  function key(s){ return String(s || '').toLowerCase().replace(/\s+/g, ' ').trim(); }
  function hexToRgb(h){
    h = String(h).replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    var n = parseInt(h, 16);
    return [(n >> 16) & 255, (n >> 8) & 255, n & 255];
  }
  function bgUrl(el){
    if (!el) return '';
    var bg = el.style.backgroundImage || getComputedStyle(el).backgroundImage || '';
    var m = /url\((['"]?)(.*?)\1\)/.exec(bg);
    return m ? m[2] : '';
  }
  function small(url, w){
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    if (/[?&]width=\d+/.test(url)) return url.replace(/([?&]width=)\d+/, '$1' + w);
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }
  function median(a){ a.sort(function(x, y){ return x - y; }); return a[Math.floor(a.length / 2)]; }

  /* mode 'photo': the middle patch of a product photo, where the garment sits.
     The median is used so a chest logo, a seam or a shadow does not skew the shade.
     mode 'swatch': the whole swatch image, averaged. */
  function sample(url, mode){
    var id = mode + '|' + url;
    if (!url || SAMPLED[id] !== undefined) return;
    SAMPLED[id] = null;
    var im = new Image();
    im.crossOrigin = 'anonymous';
    im.onload = function(){
      try {
        var W = 60;
        var H = Math.max(1, Math.round(W * (im.naturalHeight || 1) / (im.naturalWidth || 1)));
        var c = document.createElement('canvas');
        c.width = W; c.height = H;
        var x = c.getContext('2d');
        x.drawImage(im, 0, 0, W, H);
        var x0 = 0, y0 = 0, w = W, h = H;
        if (mode === 'photo') {
          x0 = Math.round(W * 0.40); w = Math.max(1, Math.round(W * 0.20));
          y0 = Math.round(H * 0.36); h = Math.max(1, Math.round(H * 0.18));
        }
        var d = x.getImageData(x0, y0, w, h).data, r = [], g = [], b = [];
        for (var i = 0; i < d.length; i += 4) {
          if (d[i + 3] < 128) continue;
          r.push(d[i]); g.push(d[i + 1]); b.push(d[i + 2]);
        }
        if (r.length) SAMPLED[id] = [median(r), median(g), median(b)];
      } catch (e) {}
    };
    im.src = mode === 'photo' ? small(url, 160) : url;
  }

  /* The colour swatch currently ticked in the product's option picker */
  function selected(scope){
    var labels = (scope || document).querySelectorAll('label.color-swatch[for]');
    for (var i = 0; i < labels.length; i++) {
      var input = document.getElementById(labels[i].getAttribute('for'));
      if (input && input.checked) return { name: input.value, url: bgUrl(labels[i]) };
    }
    return null;
  }
  function scopeOf(form){
    return (form.closest && form.closest('quick-view, .quick-view, .shopify-section')) || document;
  }
  function colourIndex(){
    if (!P) return -1;
    var names = P.options || [];
    for (var i = 0; i < names.length; i++) {
      var n = typeof names[i] === 'string' ? names[i] : (names[i].name || '');
      if (/colou?r/i.test(n)) return i;
    }
    return -1;
  }
  function variantOf(form){
    if (!P || !P.variants) return null;
    var idEl = form.querySelector('[name="id"]');
    var id = idEl ? String(idEl.value) : '';
    for (var k = 0; k < P.variants.length; k++) { if (String(P.variants[k].id) === id) return P.variants[k]; }
    return null;
  }
  function photoOf(v){
    if (v && v.featured_image && v.featured_image.src) return v.featured_image.src;
    if (!P) return '';
    /* No photo tied to the variant: only safe to use the main photo when the product has one colour */
    var ci = colourIndex(), seen = {}, n = 0;
    if (ci > -1) P.variants.forEach(function(x){ var c = x['option' + (ci + 1)]; if (!seen[c]) { seen[c] = 1; n++; } });
    if (n > 1) return '';
    if (typeof P.featured_image === 'string' && P.featured_image) return P.featured_image;
    var m = (P.media || []).filter(function(x){ return x.media_type === 'image' && x.src; })[0];
    return m ? m.src : '';
  }

  function colourOf(form){
    var sel = selected(scopeOf(form));
    var v = variantOf(form);
    var ci = colourIndex();
    var name = sel && sel.name ? sel.name : (v && ci > -1 ? (v['option' + (ci + 1)] || '') : '');
    var k = key(name);
    if (OVERRIDES[k]) return hexToRgb(OVERRIDES[k]);
    if (v) {
      var photo = photoOf(v);
      if (photo && SAMPLED['photo|' + photo]) return SAMPLED['photo|' + photo];
    }
    if (FALLBACK[k]) return hexToRgb(FALLBACK[k]);
    if (sel && sel.url && SAMPLED['swatch|' + sel.url]) return SAMPLED['swatch|' + sel.url];
    return null;
  }

  function flash(btn, rgb){
    var old = btn.querySelector('.fu-atc-flash');
    if (old) old.remove();
    var r = btn.getBoundingClientRect();
    var recent = (Date.now() - last.t) < 1500 && last.x !== null;
    var inside = recent && last.x >= r.left && last.x <= r.right && last.y >= r.top && last.y <= r.bottom;
    var px = inside ? last.x - r.left : r.width / 2;
    var py = inside ? last.y - r.top : r.height / 2;

    var f = document.createElement('span');
    f.className = 'fu-atc-flash';
    f.setAttribute('aria-hidden', 'true');
    f.style.setProperty('--fx', px + 'px');
    f.style.setProperty('--fy', py + 'px');
    btn.classList.add('fu-atc-on');
    if (rgb) {
      f.style.background = 'rgb(' + rgb[0] + ',' + rgb[1] + ',' + rgb[2] + ')';
      var lum = (0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]) / 255;
      btn.style.setProperty('--fu-atc-text', lum > 0.6 ? '#111111' : '#ffffff');
      btn.classList.add('fu-atc-tint');
    } else {
      btn.classList.remove('fu-atc-tint');
    }
    btn.insertBefore(f, btn.firstChild);

    /* Text colour goes back just as the fill starts to fade */
    setTimeout(function(){ if (f.isConnected) btn.classList.remove('fu-atc-tint'); }, HOLD);
    f.addEventListener('animationend', function(e){
      if (e.animationName !== 'fu-atc-out') return;
      f.remove();
      if (!btn.querySelector('.fu-atc-flash')) { btn.classList.remove('fu-atc-on'); btn.classList.remove('fu-atc-tint'); }
    });
  }

  document.addEventListener('pointerdown', function(e){
    last.x = e.clientX; last.y = e.clientY; last.t = Date.now();
  }, true);

  document.addEventListener('submit', function(e){
    var form = e.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var btn = e.submitter;
    if (!btn || !btn.matches || !btn.matches('button')) {
      btn = (form.id && document.querySelector('button[name="add"][form="' + form.id + '"]')) || form.querySelector('button[type="submit"]');
    }
    if (!btn || btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    flash(btn, colourOf(form));
  }, true);

  /* Get every colour ready before the click so the flash is instant */
  function primePhotos(){
    if (!P || !P.variants) return;
    var ci = colourIndex(), seen = {};
    P.variants.forEach(function(v){
      var c = ci > -1 ? String(v['option' + (ci + 1)] || '') : 'all';
      if (seen[c]) return;
      seen[c] = 1;
      var photo = photoOf(v);
      if (photo) sample(photo, 'photo');
    });
  }
  function primeSwatch(){
    var sel = selected(document);
    if (sel && sel.url) sample(sel.url, 'swatch');
  }
  function loadProduct(){
    var m = window.location.pathname.match(/\/products\/([^\/?#]+)/);
    if (!m || P) return;
    fetch('/products/' + m[1] + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function(r){ return r.ok ? r.json() : null; })
      .then(function(j){ P = j; primePhotos(); })
      .catch(function(){});
  }
  function init(){ primeSwatch(); loadProduct(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('change', function(){ setTimeout(primeSwatch, 0); }, true);
})();
